import React, { useMemo } from "react"
import { BlockContentValue, TextStyle } from "@silversea-ssc/ui-components-react"
import { SanityLocationFilter, SanityFormDisclaimer } from "../../app-core/_common/sanity/sanity-types"
import { isPresent } from "../../app-core/_common/checks"
import { matchesAny } from "../../app-core/_common/location-filter"
import BlockContent from "../BlockContent/BlockContent"

type Props = {
    countryPath: string
    content: SanityFormDisclaimer
}
const Disclaimer: React.FC<React.PropsWithChildren<Props>> = ({ content, countryPath }) => {
    const disclaimer = useMemo(() => toSpecificContent(content, countryPath), [content, countryPath])

    if (!disclaimer) return null

    return (
        <React.Fragment>
            <TextStyle fontSize="inherit">
                <BlockContent value={disclaimer} />
            </TextStyle>
        </React.Fragment>
    )
}

const toSpecificContent = (
    allContents: SanityFormDisclaimer,
    countryPath: string | undefined,
): BlockContentValue | undefined => {
    const content = allContents?.disclaimer

    const overrideContent = allContents?.overrideDisclaimer
        ?.map((slide) => {
            const content = slide.content
            if (!content) return undefined

            return {
                ...slide,
                content,
            }
        })
        .filter(isPresent)
        .find(filterByGeolocation(countryPath))

    return overrideContent?.content || content
}

const filterByGeolocation =
    (countryPath: string | undefined) =>
    (slide: { content: BlockContentValue; locationFilters?: SanityLocationFilter[] }) => {
        const filters = slide.locationFilters
        if (!isPresent(filters)) return false

        return matchesAny(filters, countryPath)
    }

export default Disclaimer
